import { useMemo } from 'react';
import { useCollections } from './useCollections';
import { GameCategory } from '@repo-level/core-front';

export const useThemes = () => {
  const { collections } = useCollections();

  const themes = useMemo(() => {
    if (!collections) return new Map();

    const result = new Map<string, GameCategory>();
    collections.forEach((category) => {
      if (category.id.startsWith('@')) {
        result.set(category.id, category);
      }
    });
    return result;
  }, [collections]);

  return { themes };
};
